import { events as eventTypes } from '../../../proto/protobuf';
import { SearchResultType } from '../../../state/types';

import { loadProtobuf } from './lazyExports';

type GetProtobufSearchScope = (
  resultType: SearchResultType,
  groupTelemetryId?: string
) => Promise<eventTypes.ThreadSearchSubmittedV1.Scope>;
export const getProtobufSearchScope: GetProtobufSearchScope = async (resultType, groupTelemetryId) => {
  const { events } = await loadProtobuf();

  const SearchScope = events.ThreadSearchSubmittedV1.Scope;

  if (resultType === SearchResultType.Inbox) {
    return SearchScope.INBOX;
  }

  if (groupTelemetryId != null) {
    return SearchScope.GROUP;
  }

  return SearchScope.ALL;
};
